<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" style="background-image: url(assets/images/commercial-bg.jpg);">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/history">History of LCCC</a></li>
                            <li><a routerLink="/museum">Museum</a></li>
                            <li><a routerLink="/honours">Honours</a></li>
                            <li><a routerLink="/records" class="active">Records</a></li>
                            <li><a routerLink="/ground">Ground Devlopments</a></li>                                 
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="honours-hero-section cf">
        <div class="container">
            <div class="honours-hero-detail">
                <div class="titel-box">
                    <h2 class="titel-name">Records</h2>
                </div>
                <div class="record-hero-detail cf">
                    <div class="record-content">
                        <p>{{recordsList?.data?.title}}</p>
                    </div>
                    <div class="record-bottom-detail">
                        <div class="record-team">
                            <ul>
                                <li *ngFor="let rec of recordsList?.data?.history_records_detail"><a href="{{rec?.pdf}}" download>{{rec?.title}}</a></li>
                                <!-- <li><a href="#">LCCC List A Records - Team</a></li>
                                <li><a href="#">LCCC T20 Records - Team</a></li> -->
                            </ul>
                        </div>
                        <!-- <div class="record-individual">
                            <ul>
                                <li><a href="#">LCCC Frist-Class Records - Individual</a></li>
                                <li><a href="#">LCCC List A Records - Individual</a></li>
                                <li><a href="#">LCCC T20 Records -  Individual</a></li>
                            </ul>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->